module.exports = __webpack_public_path__ + "img/ARAB-HEALTH2018.07c26b47.png";